import Avatar from "react-avatar";
import Gallery from "./Gallery";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";

// Gallery of student artworks
function StudentGallery(props) {
    const { blue, white } = useContext(ColorContext);

    let student = props.student;

    return(
        <div className="student" data-artist={student}>
            <div id="student-header">
                <Avatar id="student-avatar" name={student.first_name + " " + student.last_name} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                <p id="student-name">{student.first_name + " " + student.last_name}</p>
                <p id="student-email">{student.email}</p>
            </div>            
            <Gallery artSelector={props.artSelector} artist={student}/>
        </div>
    )
}

export default StudentGallery;